import { node, func } from 'prop-types'
import { Children, Component, cloneElement } from 'react'
import { findDOMNode } from 'react-dom'
import { registerListener, removeListener, bodyClick } from './bodyClicks'

export { registerListener, removeListener, bodyClick }

export function trackDisconnected(elem) {
  this.disconnectedChildren = this.disconnectedChildren || []
  this.disconnectedChildren.push(elem)
}

export function disconnectedChild(component, target) {
  if (!component || !component.disconnectedChildren) {
    return false
  }
  return (
    component.disconnectedChildren.filter(
      (child) => child && child.contains(target)
    ).length > 0
  )
}

export default class WithOutsideTracking extends Component {
  static propTypes = {
    children: node.isRequired,
    getTrackingContext: func,
    onOutsideClick: func.isRequired,
    ref: func,
  }

  componentDidMount() {
    registerListener(this)
  }

  componentWillUnmount() {
    removeListener(this)
  }

  bodyClicked(e) {
    if (this.trackedComponent) {
      const domElement = this.trackedElement
      if (
        domElement &&
        domElement !== e.target &&
        !domElement.contains(e.target) &&
        !disconnectedChild(
          this.componentContext || this.trackedComponent,
          e.target
        )
      ) {
        if (this.props.onOutsideClick) {
          this.props.onOutsideClick()
        }
      }
    }
  }

  get trackedElement() {
    // eslint-disable-next-line react/no-find-dom-node
    return findDOMNode(this.trackedComponent)
  }

  trackComponent(component) {
    if (component) {
      this.trackedComponent = component
      if (this.props.ref) {
        this.props.ref(component)
      }
    }
  }

  render() {
    const {
      children,
      getTrackingContext,
      onOutsideClick, // eslint-disable-line no-unused-vars
      ...childProps
    } = this.props

    if (getTrackingContext) {
      this.componentContext = getTrackingContext()
      this.trackComponent(this.componentContext)
    }
    if (typeof children === 'object') {
      return cloneElement(Children.only(children), {
        ...childProps,
      })
    }
    return cloneElement(Children.only(children), {
      ...childProps,
      ref: this.trackComponent.bind(this, this),
    })
  }
}
